<template>
    <div class="picture-card-wrap" @mousemove="moveHandle" @mouseout="outHandle">
        <div class="import-image">
            <img class="card-img" :src="data.imgUrl" />
        </div>
        <IconInput class="img-name-input" :initValue="imgName" @inputChange="nameChange" :placeholder="imgPlaceholder" />
        <TagSelect class="img-tag-select" type="image" :placeholder="tagPlaceholder" :selected="data.imgTags" @clickSelect="selectHandler"> </TagSelect>
        <DeleteIcon class="card-delete" v-show="showDelIcon" @iconClick="deleteItem" />
    </div>
</template>

<script>
import DeleteIcon from "@/views/zhiji/bComponents/icons/DeleteIcon";
import TagSelect from "@/views/zhiji/components/materialLibrary/TagSelect";
import IconInput from "@/views/zhiji/bComponents/inputs/IconInput";

export default {
    name: "PictureCard",
    props: ["data"],
    components: {
        DeleteIcon,
        TagSelect,
        IconInput
    },
    data() {
        return {
            showDelIcon: false,
            imgName: this.data.name || "",
            imgTags: ""
        };
    },
    computed: {
        imgPlaceholder() {
            return this.$t("zhiji.materialLibrary.picEnterTip");
        },
        tagPlaceholder() {
            return this.$t("zhiji.materialLibrary.chosePicLabel");
        }
    },
    methods: {
        nameChange(data) {
            this.imgName = data;
            this.$emit("nameChange", {
                newData: this.imgName,
                data: this.data
            });
        },
        selectHandler(data) {
            this.imgTags = data;
            this.$emit("tagsChange", {
                newData: this.imgTags,
                data: this.data
            });
        },
        deleteItem(data) {
            this.$emit("deleteImage", this.data);
        },
        moveHandle() {
            this.showDelIcon = true;
        },
        outHandle() {
            this.showDelIcon = false;
        }
    }
};
</script>

<style lang="less" scoped>
.picture-card-wrap {
    position: relative;
    border: 1px solid #d8e4f0;
    border-radius: 4px;
    padding: 16px;
    margin: 8px 16px 16px 0;
    height: 283px;
    box-sizing: border-box;
    .import-image {
        margin-bottom: 8px;
        .card-img {
            width: 210px;
            height: 152px;
            border-radius: 4px;
        }
    }
    .img-name-input {
        margin-bottom: 8px;
        border: solid 1px #d8e4f0;
        width: 100%;
    }
    .img-tag-select {
        width: 210px;
    }
    .card-delete {
        z-index: 1;
        right: -8px;
        top: -8px;
        position: absolute;
    }
}
</style>
